import React, { useState, useEffect } from 'react';
import './SurveyResponsesSurveyContactList.css';
import SurveyResponsesSurveyContactCard from './SurveyResponsesSurveyContactCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';
import Pager from '../Pager/Pager';

const CONTACTS_PER_PAGED_VIEW = 5;

export default function SurveyResponsesSurveyContactList({ contacts, onSelect, fullWidth, selectedContact }) {
  const [searchTerms, setSearchTerms] = useState('');
  const [visibleContacts, setVisibleContacts] = useState(contacts);
  const [currentPage, setCurrentPage] = useState(1);

  if (logComponent('SurveyResponsesSurveyContactList')) { console.debug('SurveyResponsesSurveyContactList rendered'); }


  useEffect(() => {
    if (logComponent('SurveyResponsesSurveyContactList')) { console.debug('SurveyResponsesSurveyContactList useEffect  [contacts, searchTerms]'); }
    updateVisibleContacts();
  }, [contacts, searchTerms])


  const updateSearchTerms = (e) => {
    if (logComponent('SurveyResponsesSurveyContactList')) { console.debug('SurveyResponsesSurveyContactList updateSearchTerms'); }
    setSearchTerms(e.target.value);
  }


  const updateVisibleContacts = () => {
    if (logComponent('SurveyResponsesSurveyContactList')) { console.debug('SurveyResponsesSurveyContactList updateVisibleContacts'); }

    let filteredContacts = contacts.filter(collection => {

      return collection.name.toLowerCase().includes(searchTerms.toLowerCase());
    });

    setVisibleContacts(filteredContacts);
  }

  const updateSelectedSurveyContact = (surveyContact) => {
    if (logComponent('SurveyResponsesSurveyContactList')) { console.debug('SurveyResponsesSurveyContactList updateSelectedSurveyContact'); }
    onSelect(surveyContact);
  }

  const selectPage = (surveyPage) => {
    if (logComponent('SurveyResponsesSurveyList')) { console.debug('SurveyResponsesSurveyList selectSurveyPage'); }

    if (selectedContact && visibleContacts && visibleContacts.length > 0) {
      let newSelectedContacts = visibleContacts.slice((surveyPage - 1) * CONTACTS_PER_PAGED_VIEW, surveyPage * CONTACTS_PER_PAGED_VIEW)[0];
      onSelect(newSelectedContacts);

    }

    setCurrentPage(surveyPage);
  }

  return (
    <div className={'Survey-Response-Survey-Contact-List' + (fullWidth ? ' Survey-Response-Survey-Contact-List--full-width' : '')}>
      <div className="Survey-Response-Survey-Contact-List__search-wrapper">
        <FontAwesomeIcon icon="search" className="Survey-Response-Survey-Contact-List__search-icon" />
        <input
          type="text"
          className="Survey-Response-Survey-Contact-List__search-input"
          placeholder="Search contacts"
          value={searchTerms}
          onChange={updateSearchTerms} />
      </div>
      <div className="Survey-Response-Survey-Contact-List__pager">
        <Pager
          items={visibleContacts.length}
          onChange={selectPage}
          selectedPage={currentPage}
          pageSize={CONTACTS_PER_PAGED_VIEW}
        />
      </div>

      <ul className="Survey-Response-Survey-Contact-List__contacts">
        {
          visibleContacts
            .slice((currentPage - 1) * CONTACTS_PER_PAGED_VIEW, currentPage * CONTACTS_PER_PAGED_VIEW)
            .map(surveyContact =>
            <SurveyResponsesSurveyContactCard
              key={surveyContact.surveyContactId}
              fullWidth={fullWidth}
              surveyContact={surveyContact}
              onClick={updateSelectedSurveyContact}
              selected={!fullWidth && selectedContact ? surveyContact.surveyContactId === selectedContact.surveyContactId : false} />
          )
        }
      </ul>
      {
        !visibleContacts ||
        (visibleContacts &&
          visibleContacts.length === 0) &&
        <p className="Survey-Response-Survey-Contact-List__empty-message">No contacts found...</p>
      }
    </div>
  );
}